import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { goHome } from "../utils/homeNavigation";
import {
  HomeFilled,
  AppstoreFilled,
  ReadFilled,
  MedicineBoxFilled,
  UserOutlined
} from "@ant-design/icons";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  let user = null;

  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    user = null;
  }

  const path = location?.pathname || "/";

  const items = [
    {
      label: "Trang chủ",
      icon: <HomeFilled />,
      active: path === "/",
      click: () =>
        goHome(
          path,
          navigate,
          () => window.location.reload()
        )
    },
    {
      label: "Danh mục",
      icon: <AppstoreFilled />,
      active:
        path.startsWith("/danh-muc-san-pham") ||
        path.startsWith("/danh-muc-moi") ||
        path.startsWith("/danh-muc-con"),
      click: () => navigate("/danh-muc-san-pham/Sach-and-Tai-Lieu")
    },
    {
      label: "Blog",
      icon: <ReadFilled />,
      active: path === "/blog" || path.startsWith("/blog/"),
      click: () => navigate("/blog")
    },
    {
      label: "Tiện ích",
      icon: <MedicineBoxFilled />,
      active: path === "/tienich" || path.startsWith("/tienich/"),
      click: () => navigate("/tienich")
    },
    {
      label: "Tài khoản",
      icon: <UserOutlined />,
      active:
        path.startsWith("/thong-tin-ca-nhan") ||
        path.startsWith("/sach-cua-toi") ||
        path.startsWith("/dang-nhap"),
      click: () =>
        navigate(user ? "/thong-tin-ca-nhan" : "/dang-nhap")
    }
  ];

  return (
    <nav className="liquid-bottom-nav cyk-bottom-nav">
      {items.map((item) => (
        <button
          key={item.label}
          type="button"
          onClick={item.click}
          className={`liquid-bottom-item cyk-bottom-item ${
            item.active ? "is-active" : ""
          }`}
        >
          <span className="liquid-bottom-icon cyk-bottom-icon">
            {item.icon}
          </span>

          <span className="liquid-bottom-label cyk-bottom-label">
            {item.label}
          </span>
        </button>
      ))}
    </nav>
  );
}
